import { Badge } from '@indipia/ui-core'
import { formatReceivedAt, statusBadgeTone } from '@indipia/shared-features'
import type { CustReqDelivered } from '../../types/custReqProgress.types'
import { CustReqPhotoStrip } from './CustReqPhotoStrip'

// 작업요청 팝업의 '전달된 고객 요청 n건' — 번호 · 원문 · 경로 · 접수일 · 사진, 지금 상태(전달됨·반영됨·확인). 읽기 전용(941 S16-4).
// 요청이 없으면(필드 없음 포함) 영역을 그리지 않는다.

const caption: React.CSSProperties = { fontSize: 'var(--type-caption-size)', color: 'var(--shell-on-surface-2)' }

interface Props {
  items: CustReqDelivered[] | undefined
  onViewerOpenChange?: (open: boolean) => void
}

export function DeliveredCustReqList({ items, onViewerOpenChange }: Props) {
  if (!items || items.length === 0) return null
  return (
    <section className="mt-2.5" aria-label="전달된 고객 요청">
      <div className="text-xs font-bold" style={{ color: 'var(--shell-on-surface)' }}>{`전달된 고객 요청 ${items.length}건`}</div>
      <ul className="mt-1.5 flex flex-col gap-2 list-none p-0 m-0">
        {items.map((r, i) => {
          const received = formatReceivedAt(r.receivedAt)
          const meta = [r.srcName, received && `${received} 접수`].filter(Boolean).join(' · ')
          return (
            <li key={r.custReqId} className="rounded-lg p-2" style={{ border: 'var(--border-width-hairline) solid var(--shell-border)' }}>
              <div className="flex items-start gap-1.5">
                <span className="text-sm font-bold" style={{ color: 'var(--shell-on-surface)' }}>{`${i + 1}.`}</span>
                <span className="flex-1 min-w-0 text-sm" style={{ color: 'var(--shell-on-surface)', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{r.content}</span>
                <Badge status={statusBadgeTone(r.statusCode)}>{r.statusName}</Badge>
              </div>
              {meta && <div className="mt-1" style={caption}>{meta}</div>}
              {(r.photos?.length ?? 0) > 0 && (
                <div className="mt-1.5">
                  <CustReqPhotoStrip
                    photos={r.photos.map(p => ({ id: p.photoId, thumbUrl: p.thumbUrl, url: p.url }))}
                    alt="고객 요청 사진"
                    onViewerOpenChange={onViewerOpenChange}
                  />
                </div>
              )}
            </li>
          )
        })}
      </ul>
    </section>
  )
}
